import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  Button,
  Dropdown,
  Flex,
  Space,
  Avatar,
  message,
  Modal,
  Typography,
  Form,
  Input,
} from "antd";
import { Header } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import "./SideMenu.css";
import http from "@/utils/http";
import api from "@/utils/api";
import UserIcon from '@/assets/images/home/user.png';
import Password1 from '@/assets/images/home/password1.png';
import Password2 from '@/assets/images/home/password2.png';
const { Text, Link } = Typography;
const TopHeader = ({ showMenu, currentMenu }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [fullName, setFullName] = useState(null);
  const [form] = Form.useForm();
  const [modelReset, setModelReset] = useState(false);
  const [avatarText, setAvatarText] = useState(""); 
  const [loading, setLoading] = useState(false);
  const boxStyle = {
    width: "100%",
    borderRadius: 6,
  };
  const items = [
    // {
    //   key: "1",
    //   label: <div>Admin</div>,
    //   disabled: false,
    // },
    {
      key: "2",
      onClick: () => setModelReset(true),
      label: "Password Reset",
    },
    {
      key: "3",
      danger: true,
      label: "Sign Out",
    },
  ];
  const handleMenuClick = (e) => {
    if(e.key === "3"){
      sessionStorage.removeItem('expectedMenu');
      sessionStorage.removeItem('redirectPath');
      localStorage.clear();
      window.location.href = `${window.location.origin}#/login`;
    }
  }
  const onMenu = () => {
    setCollapsed(!collapsed);
    showMenu(collapsed);
  };
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  // 确认密码校验
  const validateConfirmPassword = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue("newPassword") === value) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error("The passwords entered twice are inconsistent.")
      );
    },
  });
  // 重置密码提交表单
  const onFinish = async (values) => {
    try {
      const { ...passwords } = values;
      // console.log("密码数据:", passwords);
      const accountId = localStorage.getItem("accountId");
      const queryParams = {
        accountId,
        oldPassword: passwords.oldPassword,
        password: passwords.newPassword,
        confirmPassword: passwords.confirmPassword,
      };
      // console.log("queryParams", queryParams);
      const response = await http.post(`${api.editPassword}`, queryParams);
      if (response.code === "1") {
        message.success("Password modified successfully.");
        setModelReset(false);
        form.resetFields();
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error("Password modification failed.");
    } finally {
      // setLoading(false);
    }
  };
  // 修改密码
  // 密码校验规则
  const passwordRules = [
    { required: true, message: "Please enter the password." },
    { min: 8, message: "The password must be at least 8 characters." },
    { max: 20, message: "The password has a maximum of 20 characters." },
    { validator: (_, value) => 
      !value || !value.includes(',') 
        ? Promise.resolve() 
        : Promise.reject(new Error('Password cannot contain commas.'))
    },
  ];
  const currentDate = new Date();
  const weekday = currentDate.toLocaleDateString('en-US', { weekday: 'long' });
  const monthAndDay = currentDate.toLocaleDateString('en-US', {  month: 'long', day: 'numeric' });
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const userObject = storedUser ? JSON.parse(storedUser) : null;

    if (userObject) {
      setFullName(`${userObject.firstName} ${userObject.lastName}`);
    }
  }, []);

  const encryptPasswordFn = async() => {
    const flag = localStorage.getItem('encryptPassword')
    if(!flag) return
    const response = await http.get(api.checkEncryptPasswordStrength, {params: {encryptPassword: localStorage.getItem("encryptPassword")}});
    if (response?.code === "1") {
      if(!response?.data?.isPasswordStrongEnough){
       const modal = Modal.confirm({
          icon: null,
          closable: true,
          centered: true,
          width: 500,
          afterClose: () => {
            localStorage.removeItem('encryptPassword')
          },
          footer: [
            <div style={{textAlign: 'right', marginTop: 10}}>
              <Button className="OKBtn" type="primary" onClick={ () => (modal.destroy(), setModelReset(true))}>
                Make it stronger
              </Button>
            </div>
          ],
          title: (
            <div style={{display: 'flex'}}>
              <img
                src={Password1}
                alt=""
                style={{ width: '40px', height: '40px', marginRight: 20 }}
              />
              <div>
                <div>Password is too weak</div>
                <div style={{ fontSize: 12, color: '#99A1AF' }}>To keep your account safe, choose a stronger password.</div>
              </div>
            </div>
          ),
          content: (
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 20}}>
              <div style={{display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                <img
                  src={Password2}
                  alt=""
                  style={{ width: '20px', height: '20px', marginRight: 10, }}
                />
                Try these:
              </div>
              {['Use 8+ characters', 'Mix uppercase, lowercase, numbers, or symbols', 'Avoid common words (e.g. password, 123456)', "Don't reuse a password from another site"].map((item, index) => (
                <div style={{display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                  <span style={{ marginRight: 10 }}>{index + 1}.</span>
                  {item}
                </div>
              ))}
            </div>
          ),
        });
      }
    }
  }
useEffect(() => {
  const storedUser = localStorage.getItem("user");
  const userObject = storedUser ? JSON.parse(storedUser) : null;

  if (userObject) {
    const first = (userObject.firstName || "").trim();
    const last = (userObject.lastName || "").trim();

    setFullName(`${first} ${last}`.trim());

    const firstLetter = first ? first[0] : "";
    const lastLetter = last ? last[0] : "";
    const initials = (firstLetter + lastLetter || "U").toUpperCase(); // 没有就用 U

    setAvatarText(initials);
  }
}, []);
  useEffect(() => {
    encryptPasswordFn()
  }, [])

  return (
    <div>
      <Header style={{ padding: 0, background: "#Ffff",borderBottom: "1px solid #E2E8F0"}}>
        <Flex style={boxStyle} justify="space-between" align="flex-start">
          <div className="topLeft">
         <Button
            type="text"
            icon={
              collapsed ? (
                <MenuUnfoldOutlined className="custom-icon" style={{ fontSize: '18px', color: '#2563EB' }} />
              ) : (
                <MenuFoldOutlined className="custom-icon" style={{ fontSize: '18px', color: '#2563EB' }}/>
              )
            }
            onClick={() => onMenu()}
            style={{
              fontSize: "16px",
              width: 55,
              height: 55,
          
            }}
          />
          <div className="topDate">
            <span className="weekDay">{weekday}, </span> <span className="monthDay">{monthAndDay}</span>
          </div>
           <div className="custom-divider" />
            {currentMenu && (
          <div className="showMenu"><span className="showMenuText">{currentMenu}</span></div>)}
          </div>
   
          <div className="topRight">
          
  <Dropdown
  overlayClassName="user-dropdown"   
  menu={{
    items,
    onClick: (e) => handleMenuClick(e),
  }}
>
  <Space>
    <Avatar
      size={36}
      className="headL"
      style={{
        backgroundColor: "#2563EB",
        color: "#fff",
        fontWeight: 600,
        fontSize: 16,
      }}
    >
      {avatarText || "U"}
    </Avatar>
  </Space>
</Dropdown>
              <span className="fullName">{fullName}</span>
          </div>
        </Flex>
      </Header>

      {/* Modal  */}
      <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <EditOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              PASSWORD RESET
            </Typography.Title>
          </Flex>
        }
        width="50%"
        open={modelReset}
        onCancel={() => setModelReset(false)}
        afterClose={() => form.resetFields()}
        footer={[
          <Button key="back" onClick={() => setModelReset(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>,
        ]}
      >
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div className="model_content">
              <Form
                {...layout}
                name="passwordResetForm"
                onFinish={onFinish}
                form={form}
                labelCol={{
                  style: {
                    width: "150px", // 设置固定宽度
                  },
                }}
                wrapperCol={{
                  style: {
                    flex: 1, // 让输入框占满剩余空间
                  },
                }}
              >
                <Form.Item name="oldPassword" label="Old Password">
                  <Input.Password
                    placeholder="Please enter a old password."
                    allowClear
                  />
                </Form.Item>
                <Form.Item
                  name="newPassword"
                  label="New Password"
                  rules={passwordRules}
                >
                  <Input.Password
                    placeholder="Please enter a new password."
                    allowClear
                  />
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  label="confirm Password"
                  dependencies={["newPassword"]}
                  rules={[
                    {
                      required: true,
                      message: "Please enter the password again.",
                    },
                    validateConfirmPassword,
                  ]}
                >
                  <Input.Password
                    placeholder="Please enter the password again."
                    allowClear
                  />
                </Form.Item>
              </Form>
            </div>
          </div>
        </Flex>
      </Modal>
    </div>
  );
};
export default TopHeader;
